import { defineComponent } from 'vue';
import { QIcon, QInput } from 'quasar';
import './flowv2ListToolbar.css';

export default defineComponent({
    name: 'flow-v2-list-toolbar',
    components: { QIcon, QInput },
    props: {
        modelValue: { type: String, default: '' },
        placeholder: { type: String, default: 'Search' },
    },
    emits: ['update:modelValue'],
    render() {
        const actions = this.$slots.default?.();
        return (
            <div class="flowv2-list-toolbar">
                <QInput
                    class="flowv2-list-toolbar__search q-mb-none"
                    dense
                    borderless
                    hide-bottom-space
                    placeholder={this.placeholder}
                    autocomplete="off"
                    clearable
                    modelValue={this.modelValue ?? ''}
                    onUpdate:modelValue={(v) => this.$emit('update:modelValue', v ?? '')}
                    v-slots={{ prepend: () => <QIcon name="mdi-magnify" /> }}
                />
                {actions ? <div class="flowv2-list-toolbar__actions">{actions}</div> : null}
            </div>
        );
    },
});
